import { defineStyle } from "@chakra-ui/react";

export const learnSideNavStyles = (isMobile = false) => {
  return {
    drawerBodyStyle: defineStyle({
      backgroundColor: "white.900",
      overflow: "auto",
      scrollBehavior: "smooth",
    }),
    drawerContentStyle: defineStyle({
      maxHeight: isMobile ? "80vh" : "100vh",
      height: isMobile ? "auto" : "100vh",
      borderTopRadius: isMobile ? "12px" : "0",
    }),
    errorContainer: defineStyle({
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    }),
    errorSubtopicsTitle: defineStyle({
      fontFamily: "Poppins",
      fontWeight: "600",
      fontSize: "24px",
      lineHeight: "32px",
      textAlign: "center",
      color: "#667085",
    }),
    errorSubtopicsDescription: defineStyle({
      fontFamily: "Poppins",
      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "28px",
      textAlign: "center",
      color: "#667085",
    }),
    loadingContainer: defineStyle({
      width: "100%",
      alignItems: "center",
      justifyContent: "center",
      mt: "40px",
    }),
  };
};
